export default function RejectedPassingTest() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2016 11.9996L22.3516 2.84961C22.6891 2.51211 22.6891 1.98711 22.3516 1.64961C22.0141 1.31211 21.4891 1.31211 21.1516 1.64961L12.0016 10.7996L2.85156 1.64961C2.51406 1.31211 1.98906 1.31211 1.65156 1.64961C1.31406 1.98711 1.31406 2.51211 1.65156 2.84961L10.8016 11.9996L1.65156 21.1496C1.31406 21.4871 1.31406 22.0121 1.65156 22.3496C1.80156 22.4996 2.02656 22.6121 2.25156 22.6121C2.47656 22.6121 2.70156 22.5371 2.85156 22.3496L12.0016 13.1996L21.1516 22.3496C21.3016 22.4996 21.5266 22.6121 21.7516 22.6121C21.9766 22.6121 22.2016 22.5371 22.3516 22.3496C22.6891 22.0121 22.6891 21.4871 22.3516 21.1496L13.2016 11.9996Z"
        fill="#BA0C2F"
      />
    </svg>
  );
}
